import React, { useState, useEffect } from 'react'
import {
  RaisedClaimChatBox,
  ChatHeader,
  ChatboxBody,
  TextAreaWrapper,
} from "../../CommonPages/ClaimRaise/OrderTabs/trackDetailTypeOneStyled";
import ChatCloseIcon from 'web/assets/svg/ChatCloseIcon'
import ChatEnterIcon from "web/assets/svg/ChatEnterIcon";
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import { useDispatch } from 'react-redux';
import { postClaimMessageForAdmin } from 'redux/actions/myClaims';

const ChatboxComponent = ({ toggleFunction, item }) => {

  const dispatch = useDispatch();
  let history = useHistory()
  const [raiseClaimtoggle, setraiseClaimtoggle] = useState(false)
  const [chatMessageListForBuyer, setchatMessageListForBuyer] = useState([])
  const [privacyOptionForBuyer, setPrivacyOptionForBuyer] = useState('public')
  const [chatMessageForBuyer, setChatMessageForBuyer] = useState("")
  const [userType, setuserType] = useState("")

  useEffect(() => {
    const intervalCall = setInterval(() => {

      fetchApiForChatMessageForBuyer()

    }, 2000);
    return () => clearInterval(intervalCall)
  }, [])

  const fetchApiForChatMessageForBuyer = async () => {
    const token = localStorage.getItem('token');
    let userAuth
    if (item.buyerInfo?.locationsId) {
      userAuth = item.buyerInfo.locationsId.toString()
    }
    else {
      userAuth = item.buyerInfo?.locationId
    }

    let data = {
      userAuth: userAuth,
      userType: "BUYER",
      orderId: item.orderId,
      claimId: item.claimId,
      admin: "demo",
      date: new Date(),
      msg: chatMessageForBuyer,
      to: privacyOptionForBuyer == "public" ? "BUYER" : "ADMIN",
      from: "ADMIN",
      "private": privacyOptionForBuyer == "public" ? false : true
    }

    let response = await dispatch(postClaimMessageForAdmin(data, token));

    if (response && response.status === 'SUCCESS') {

      setchatMessageListForBuyer(response?.payload?.msg)

    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      }
    }

  }




  const postMessageForBuyer = async () => {
    if (chatMessageForBuyer.length) {
      const token = localStorage.getItem('token');
      let userAuth
      if (item.buyerInfo?.locationsId) {
        userAuth = item.buyerInfo.locationsId.toString()
      }
      else {
        userAuth = item.buyerInfo?.locationId
      }

      let data = {
        userAuth: userAuth,
        userType: "BUYER",
        orderId: item.orderId,
        claimId: item.claimId,
        admin: "demo",
        date: new Date(),
        msg: chatMessageForBuyer,
        to: privacyOptionForBuyer == "public" ? "BUYER" : "ADMIN",
        from: "ADMIN",
        "private": privacyOptionForBuyer == "public" ? false : true
      }
      setChatMessageForBuyer("")
      let response = await dispatch(postClaimMessageForAdmin(data, token));


      if (response && response.status === 'SUCCESS') {

        setchatMessageListForBuyer(response?.payload?.msg)

      } else {
        if (response.statusCode === 401) {
          localStorage.removeItem('token')
          history.push('/sign-in')
          window.location.reload(false);
        }
      }
    }
    setChatMessageForBuyer("")
  }

  return (
    <>

      <div style={{ display: 'flex', alignItems: '', padding: '5px' }}>


        <RaisedClaimChatBox style={{ right: "0", marginRight: "20px", marginTop: "10px" }}>


          <ChatHeader style={{ maxHeight: "15%", maxWidth: "", marginRight: "", backgroundColor: "" }}>
            <ChatUserIcon color="#fff" />
            <h6 style={{ marginTop: "-1%", color: "white" }}>
              Chat with Buyer
            </h6>
            <ChatCloseIcon
              className="close-icon"
              onClick={() => {
                setraiseClaimtoggle(false)
                toggleFunction(item, "BUYER")
                setuserType("")


              }}

            />
          </ChatHeader>
          <div style={{ height: "200px", overflow: "auto", display: 'flex', flexDirection: 'column-reverse' }}>
            <div>
              <ChatboxBody style={{ backgroundColor: '' }}>
                <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>

                </div>

                {chatMessageListForBuyer && chatMessageListForBuyer.map(data => {
                  return (
                    <>
                      {data.msg.length > 0 &&
                        <div className={data.from == 'ADMIN' ? 'chat-listing-user' : 'chat-listing-admin'}>
                          <ChatUserIcon color={data.from != 'ADMIN' ? "#0a5587" : "#6d7b69"} />
                          <div style={{ overflow: "hidden" }}>
                            {data.from == "ADMIN" &&
                              <p class="chat-container darker">{data.msg}</p>
                            }
                            {data.from == "BUYER" &&
                              <p class="chat-container" style={{ backgroundColor: "#0a5587" }}>{data.msg}</p>
                            }

                            <span class={data.from == 'ADMIN' ? "time-right" : "time-left"}>
                              {moment(data.date).format('MMM Do, YYYY, HH:mm')}
                            </span>
                          </div>
                        </div>
                      }
                    </>
                  )
                })}

              </ChatboxBody>
            </div>
          </div>
          {item.claimStatus !== "ADMIN_RESOLVED" &&
            <>
              <TextAreaWrapper>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <input
                      style={{ margin: '6px', appearance: 'auto' }}
                      type="radio"
                      value="private"
                      checked={privacyOptionForBuyer === "private"}
                      onChange={e => setPrivacyOptionForBuyer(e.target.value)}
                    />
                    Our team only—private to admins
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <input
                      style={{ margin: '6px', appearance: 'auto' }}
                      type="radio"
                      value="public"
                      checked={privacyOptionForBuyer === "public"}
                      onChange={e => setPrivacyOptionForBuyer(e.target.value)}
                    />
                    Post publicly - Allow buyers/sellers to see
                  </div>
                </div>
              </TextAreaWrapper>
              <TextAreaWrapper>
                <textarea
                  style={{ width: "100%" }}
                  value={chatMessageForBuyer}
                  rows="1"
                  placeholder="Please Type Message"
                  onChange={(e) =>
                    setChatMessageForBuyer(e.target.value)
                  }
                  onKeyDown={(e) => {

                    if (e.key === "Enter") {
                      postMessageForBuyer()

                    }


                  }}
                />
                <ChatEnterIcon
                  style={{ opacity: chatMessageForBuyer !== '' ? '1' : '0.5' }}
                  onClick={() => {
                    postMessageForBuyer()

                  }
                  }

                />
              </TextAreaWrapper>
            </>
          }
        </RaisedClaimChatBox>

      </div>


    </>




  )
}

export default ChatboxComponent
